import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerGroupNotificationSettingsUpdate(groupId: string, frequency: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.productGroupNotificationSettingsUpdate',
		productGroupNotificationSettingsUpdate: {
			id: groupId,
			frequency,
		},
	});
}
